import getPlayerMetadataFromIcyMetadata from '@/lib/get-player-metadata-from-icy-metadata';
import getPlayoutById from '@/lib/get-playout-by-id';
import { getTCStringSync } from '@/lib/tcf-consent';
import { Metadata } from '@/store/slices/player';
import { Channel } from '@/types/views/generic';

let localPlayerInstance: IcecastMetadataPlayer | null = null;

const getLocalStationPlayer = (
  libLoaded: boolean,
  channel: Channel | null,
  onMetadataCb: (metadata: Metadata) => void,
) => {
  if (!libLoaded) {
    return null;
  }

  if (typeof window !== 'undefined' && channel) {
    const streamUrlObj = new URL(channel.streamUrl);
    streamUrlObj.searchParams.append('ua', 'energy+website+metadata+only');

    const tcString = getTCStringSync();

    if (tcString) {
      streamUrlObj.searchParams.set(
        'aw_0_req.userConsentV2',
        encodeURIComponent(tcString),
      );
    }

    localPlayerInstance = new IcecastMetadataPlayer(streamUrlObj.toString(), {
      onMetadata: async (icyMetadata) => {
        const streamMetadata = getPlayerMetadataFromIcyMetadata(icyMetadata);

        if (streamMetadata) {
          onMetadataCb(streamMetadata);
        } else {
          return;
        }

        const { searchParams } = new URL(icyMetadata.StreamUrl);
        const playoutIdString = searchParams.get('plId');

        if (!playoutIdString) {
          return;
        }

        const playoutId = parseInt(playoutIdString, 10);

        try {
          const playout = await getPlayoutById(playoutId, channel.id);

          if (playout) {
            onMetadataCb({
              title: streamMetadata.title,
              artist: playout.song?.artists_full ?? streamMetadata.artist,

              artists:
                playout.song?.artists.map(({ id, name }) => ({
                  id,
                  name,
                })) ?? null,

              duration: playout.song?.duration,
              coverUrl: playout.resolved_cover_url,
            });
          } else {
            // TODO: ECH-3457
            console.warn('Could not get metadata from BM.');
          }
        } catch (error) {
          // TODO: ECH-3457
          console.error(error);
          console.error('AWS client sent error');
        }
      },
    });
  }

  return localPlayerInstance;
};

export default getLocalStationPlayer;
